import { t as getFixedT } from "@/i18n";
import type { SupportedLanguage } from "@/lib/site";
import "./WhyUs.css";

interface WhyUsItem {
  icon: string;
  title: string;
  body: string;
}

interface WhyUsProps {
  lang: SupportedLanguage;
}

/** #why-us — 09-landing-page.md §2, value-proposition cards (H2 + 4-up grid on desktop, stacked
 * on mobile). Icons are decorative emoji (aria-hidden); the card title carries the real meaning. */
export function WhyUs({ lang }: WhyUsProps) {
  const t = getFixedT(lang);
  const items = t("whyUs.items", { returnObjects: true }) as WhyUsItem[];

  return (
    <section id="why-us" className="fa-why-us" aria-labelledby="why-us-heading">
      <div className="fa-section-inner">
        <h2 id="why-us-heading" className="fa-section-heading">
          {t("whyUs.heading")}
        </h2>
        <div className="fa-why-us__grid">
          {items.map((item) => (
            <div className="fa-why-us__card" key={item.title}>
              <span className="fa-why-us__icon" aria-hidden="true">
                {item.icon}
              </span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
